export const UPDATE_VIEW_MODE = "UPDATE_VIEW_MODE";
